import React, { useState, useRef } from "react";
import SendIcon from "../components/svg/SendIcon";
import ISupportMessage from "../components/ISupportMessage";

const SupportFooter: React.FC<any> = ({
  allMessage,
  setAllMessage,
  scrollToBottom,
}) => {
  const [showPlaceHolder, setShowPlaceHolder] = useState(true);
  const [iMessage, setIMessage] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const changePrevState = (prevState: any) => {
    return prevState.map((item: any) => {
      // eslint-disable-next-line
      return { ...item, ["props"]: { ...item.props, ["lastItem"]: false } };
    });
  };

  const sendMessage = () => {
    if (iMessage === "" || /^\s+$/.test(iMessage)) {
      return null;
    }

    setAllMessage((prevState: any) => {
      //   console.log(prevState);
      //   var newOptions = {};
      //   if (prevState.length) {
      //     newOptions = prevState.map((value: any) => {
      //       return { ...value["props"], lastItem: false };
      //       //   console.log(value["props"]);
      //     });
      //   }
      //   console.log(newOptions);
      //   console.log(prevState);
      if (prevState.length) {
        // console.log(changePrevState(prevState));
        return [
          ...changePrevState(prevState),
          <ISupportMessage
            message={iMessage}
            scrollToBottom={scrollToBottom}
            lastItem={true}
          />,
        ];
      }

      return [
        ...prevState,
        <ISupportMessage
          message={iMessage}
          scrollToBottom={scrollToBottom}
          lastItem={true}
        />,
      ];
    });

    setIMessage("");
    textareaRef.current!.focus();
  };

  return (
    <div className="chat-support__footer">
      <div className="chat-support__footer__holder">
        <div className="chat-support__footer__holder__input">
          <textarea
            name=""
            id=""
            placeholder={showPlaceHolder ? "اینجا تایپ کنید" : ""}
            value={iMessage}
            ref={textareaRef}
            onClick={() => {
              setTimeout(() => {
                scrollToBottom();
              }, 500);
            }}
            onChange={(e: any) => {
              if (showPlaceHolder) {
                setShowPlaceHolder(false);
              }
              setIMessage(e.target.value);
            }}
          ></textarea>
        </div>
        <div className="chat-support__footer__holder__send">
          <span onClick={sendMessage}>
            <SendIcon />
          </span>
        </div>
      </div>
    </div>
  );
};

export default SupportFooter;
